import * as React from 'react';


import Box from '@mui/material/Box'


import AddIcon from '@mui/icons-material/Add'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Card from'@mui/material/Card'
import CardContent from'@mui/material/CardContent'
import CardHeader from'@mui/material/CardHeader'
import { CharismaAssessmentTemplateApi } from '../api/assessments/CharismaAssessmentTemplateApi.tsx';
import CharismaAssessmentTemplateForm from './assessmentTemplateForm.tsx';
import CharismaAssessmentTemplate from './assessmentTemplate.tsx';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';




export default function CharismaAssessmentTemplatesList(props){
    
    const [assessments, setAssessments] = React.useState([]);
    const [create, setCreate] = React.useState(false);
    const [currentId, setCurrentId] = React.useState(0);
    const [deleteAssessment, setDeleteAssessment] = React.useState(false);
    const [selected, setSelected] = React.useState([]);
    
    const lType = props.type;
    
    React.useEffect(()=>{
        const lResponse = CharismaAssessmentTemplateApi.ListAssessmentTemplates(lType);
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.assessmentTemplates !== null){
                    setAssessments(value.assessmentTemplates);
                }
                
            }
        }).catch((error)=>{
            
        })
        setSelected([]);
        setCurrentId(0);
    }, [lType])
    
    
    function handleCancel(){
        setCreate(false);
    }   
    
    
    function handleSelected(pEvent : React.ChangeEvent<HTMLInputElement>, pId : number){
        let lNewSelected : number[] = [];
        let lIndex = selected.indexOf(pId);
        if(pEvent.target.checked && lIndex === -1){
            lNewSelected = lNewSelected.concat(selected, pId);
        }
        else if(lIndex !== -1){
            if(lIndex === 0){
                lNewSelected = lNewSelected.concat(selected.slice(1));
            }
            else if(lIndex === selected.length - 1){
                lNewSelected = lNewSelected.concat(selected.slice(0, -1));
            }
            else{
                lNewSelected = lNewSelected.concat(selected.slice(0, lIndex), selected.slice(lIndex + 1),);
            }
        }
        setSelected(lNewSelected);
    }
    
    
    function handleSubmit(pName : string){
        const lResponse = CharismaAssessmentTemplateApi.CreateAssessmentTemplate(pName, lType);
        lResponse.then((value)=>{
            if(value.error === 0){
                setCreate(false);
                if(value.assessmentTemplate !== null){
                    let lAssessments = assessments.concat(value.assessmentTemplate);
                    setAssessments(lAssessments);
                }                                
            }
            else{
                
            }
        }).catch((error)=>{
            console.log("catch error")
        })
    }
    
    function handleUpdate(pTitle : string, pId : number){
        let lAssessmentsList = assessments.slice();
        for(let lIndex = 0; lIndex < lAssessmentsList.length; lIndex++){
            if(pId === lAssessmentsList[lIndex].id){
                lAssessmentsList[lIndex].title = pTitle;
                break;
            }
        }
        setAssessments(lAssessmentsList);  
    }
    
    function handleCancelUpdate(){
        setCurrentId(0);
    }
    
    function handleEdit(pId : number){
        setCurrentId(pId);
    }
    
    function handleDelete(){
        const lResponse = CharismaAssessmentTemplateApi.DeleteAssessmentTemplates(selected);
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.ids !== null){
                    let lAssessments = assessments.filter((assessment)=>(value.ids.indexOf(assessment.id) === -1));
                    setAssessments(lAssessments);
                    setSelected([]);
                    setCurrentId(0);
                }
            }
            else{
                
            }
        }).catch((error)=>{
                console.log("catch error")
        }) 
    }
    
    return(
        
        <Box>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={4}>
                    <Card>
                        <CardHeader
                            title={props.title}
                            action={
                                <div>
                                <IconButton>
                                    <AddIcon
                                        onClick={()=>setCreate(true)}
                                    />
                                </IconButton>
                                {selected.length > 0 ?
                                    <IconButton onClick={()=>setDeleteAssessment(true)}>
                                        <DeleteIcon/>
                                    </IconButton>  
                                    :
                                    null
                                } 
                                </div>
                            } 
                        />
                        <CardContent>
                            <Table>                               
                                <TableHead>
                                    <TableRow>
                                        <TableCell padding="checkbox">
                                        </TableCell>
                                        <TableCell>
                                            Titre
                                        </TableCell>
                                        <TableCell padding="checkbox">
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {
                                    assessments.map((assessment)=>(
                                        <TableRow>
                                            <TableCell>
                                                <Checkbox
                                                    checked={selected.indexOf(assessment.id) !== -1}
                                                    onClick={(event)=>handleSelected(event, assessment.id)}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {assessment.title}
                                            </TableCell>
                                            <TableCell padding="checkbox">
                                                <IconButton
                                                    onClick={()=>handleEdit(assessment.id)}
                                                >
                                                    <EditIcon/>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>     
                                    ))
                                }
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={8}>
                    {currentId >0 ?
                        <CharismaAssessmentTemplate
                            assessmentId={currentId}
                            handleUpdate={handleUpdate}
                            handleCancel={handleCancelUpdate}
                        />
                    :
                    null
                    }                
                </Grid>
            </Grid>
            {create ?
                <CharismaAssessmentTemplateForm
                    title={"Ajout d'un rapport"}
                    handleSubmit={handleSubmit}
                    handleCancel={handleCancel}
                />
                :
                null    
            }    
            <Dialog
                open={deleteAssessment}
            >
                <DialogTitle>Suppression de rapport</DialogTitle>
                <DialogContent>
                    <div>
                        <Typography>Etes-vous sûr de vouloir supprimer définitivement les rapports sélectionnés?</Typography>
                        <Alert severity='warning'>Cette action sera définitive</Alert>
                    </div>
                    
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={()=>setDeleteAssessment(false)}>
                        Annuler
                    </Button>
                    <Button onClick={()=>{handleDelete();setDeleteAssessment(false)}}>
                        Valider
                    </Button>
                </DialogActions>
            </Dialog> 
                  
        </Box>      
    );
    
    
}